import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService } from './../../shared';

import { ContactFormComponent } from './../contact-form';

@Component({
  selector: 'contact',
  template: require('./contact.component.html'),
  styles: [require('./contact.component.scss'), require('.//../static.scss')],
})
export class ContactComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService) {
  }

  title = 'Contact Us - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';

  ngOnInit() {
      this.seo.set(this.title, this.description);
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/contact/contact.component.ts